import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';

// Environments
import { environment } from '../../../environments/environment';

// Models
import { QuotaAlerts } from '../models/quota-alerts.model';
import { finalize, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';


@Injectable({
  providedIn: 'root'
})
export class QuotaService {
  private readonly http = inject(HttpClient);

  alertLvl: string = '';
  contextListQuotasLoading = signal<boolean>(false);

  getQuotaDetails() {
    this.contextListQuotasLoading.set(true);

    return toSignal(
      this.http.get<{ id: string; name: string; totalSpaceOccupied: number; }[]>(`${environment.apiGatewayUrl}/ugc/api/v1/contexts/quotadetails`)
        .pipe(
          finalize(() => this.contextListQuotasLoading.set(false))
        ),
      { initialValue: [] } // valore iniziale
    );
  }

  getQuotaAlerts() {
    return this.http.get<QuotaAlerts>(`${environment.apiGatewayUrl}/monitoring/api/v1/quota-alerts/status`)
      .pipe(tap(alert => {
        if (alert.request.usagePercent > 0 || alert.storage.usagePercent > 0) {
          this.alertLvl = this.setAlertLvl(alert);
        }
      }));
  }

  setAlertLvl(alert: QuotaAlerts) {
    if (alert.request.alertType === 'WARNING-REQUEST' || alert.storage.alertType === 'WARNING-STORAGE') {
      return 'warning';
    } else if (alert.request.alertType === 'CRITICAL-REQUEST' || alert.storage.alertType === 'CRITICAL-STORAGE') {
      return 'danger';
    } else if (alert.request.alertType === 'BLOCK-REQUEST' || alert.storage.alertType === 'BLOCK-STORAGE') {
      return 'danger';
    } else if (alert.request.alertType === 'OVERQUOTA-REQUEST' || alert.storage.alertType === 'OVERQUOTA-STORAGE') {
      return 'danger';
    } else {
      return '';
    }
  }

  resourceRequest(increaseRequest: boolean, increaseStorage: boolean, message: string) {
    return this.http.post<any>(`${environment.apiGatewayUrl}/ugc/api/v1/email/resource-request`, { request: increaseRequest, storage: increaseStorage, message });
  }
}
